<template>
  <header class="str-base-header" id="str-base-header">
    <nav>
      <div class="str-header-container">
        <div class="str-header-logo">
          <a href="/"><img id="str-logo" src="@/assets/logo.svg" /></a>
        </div>
        <div class="str-nav-links">
          <div class="header-links-left">
            <ul>
              <li class="str-dropdown">
                <a href="#" class="str-dropdown-toggle" id="str-nav-about">Products</a>
                <ul class="str-dropdown-menu">
                  <!-- TODO: re-enable once /products/structure-sdk and /products/structure-cloud pages exist
                  <li><RouterLink to="/products/structure-sdk">Structure SDK</RouterLink></li>
                  <li><RouterLink to="/products/structure-cloud">Structure Cloud</RouterLink></li> -->
                  <li><a href="https://structure.io/structure-sensor-3-for-ipad">Structure Sensor 3</a></li>
                </ul>
              </li>
              <li class="str-dropdown">
                <a href="#" class="str-dropdown-toggle" id="str-nav-products">Resources</a>
                <ul class="str-dropdown-menu">
                  <li><a :href="documentationUrl" target="_blank" @click="handleDocumentationClick" id="documentation-link">Documentation</a></li>
                  <!-- TODO: re-enable once the tutorials page at developer.structure.io is live again
                  <li><a href="https://developer.structure.io/docs/tutorials/tutorials/">Tutorials</a></li> -->
                  <li><a href="https://cloud.structure.io">Cloud Documentation</a></li>
                  <li><RouterLink to="/resources/call">Get Help</RouterLink></li>
                  <li><RouterLink to="/eula">EULA</RouterLink></li>
                </ul>
              </li>
              <li class="str-dropdown">
                <a href="#" class="str-dropdown-toggle" id="str-nav-support">Support</a>
                <ul class="str-dropdown-menu">
                  <li><a href="https://support.structure.io">Help Center</a></li>
                  <li><a href="https://structure.io/contact">Contact Us</a></li>
                  <li><a href="https://support.structure.io/article/417-structure-sdk-ios-release-notes">Release Notes</a></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="str-nav-slant"></div>
        <div class="header-links-dev">
          <button v-if="!isAuthenticated" @click="handleLogin">Log In</button>
          <button v-else-if="isAuthenticated && isOnPublicRoute" @click="router.push('/console/getstarted')">Back to Console</button>
          <button v-else-if="isAuthenticated && !isOnPublicRoute" @click="handleLogout">Log Out</button>
          <template v-if="isMobile">
      <img
        id="header-mobile-menu-btn"
        :src="mobileIcon('menu')"
        alt="menu icon"
        v-if="!mobileMenuOpen"
        @click="openMenu"
      />
      <img
        id="header-mobile-menu-close"
        :src="mobileIcon('close')"
        alt="close icon"
        v-if="mobileMenuOpen"
        @click="closeMenu"
      />
    </template>

        </div>
        <div id="header-mobile-menu" :class="mobileMenuClass">
          <ul>
            <li><img id="str-logo" src="https://store-4fwfwlzl1t.mybigcommerce.com/content/images/logos/StructureLogo-cyn-wht.svg" /></li>
            <li v-for="(item, index) in mobileMenuItems" :key="index" class="mobile-accordion">
              <div class="mobile-accordion-header" @click="toggleAccordion(item)">
                {{ item.title }}
                <img
                  class="footer-btn footer-btn-open"
                  :src="mobileIcon('plus')"
                  :class="{ active: item.open }"
                  alt="open icon"
                />
              </div>
              <ul v-show="item.open" class="mobile-accordion-content">
                <li v-for="(link, idx) in item.links" :key="idx"><a :href="link.href" :target="link.target" @click="link.onClick && link.onClick()">{{ link.text }}</a></li>
              </ul>
            </li>

            <li><button v-if="!isAuthenticated" @click="handleLogin">Log In</button>
          <button v-else-if="isAuthenticated && isOnPublicRoute" @click="router.push('/console/getstarted')">Back to Console</button>
          <button v-else-if="isAuthenticated && !isOnPublicRoute" @click="handleLogout">Log Out</button></li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter, useRoute } from "vue-router";
import { onMounted, onUnmounted, ref, computed, watch } from "vue";
import { useDocumentationTracking, MOBILE_BREAKPOINT } from '@/composables.js';


export default {
  setup() {
    const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
    const router = useRouter();
    const route = useRoute();
    const { documentationUrl, handleDocumentationClick } = useDocumentationTracking();

    const mobileMenuOpen = ref(false);
    const mobileMenuClass = ref('header-mobile-menu-closed');

    const handleLogin = () => {
      loginWithRedirect({
        appState: { target: "/console/getstarted" },
      });
    };

    const handleLogout = () => {
      logout({
        logoutParams: {
          returnTo: process.env.VUE_APP_BASE_URL,
        },
      });
    };

    const mobileMenuItems = ref([
      { title: 'Products', open: false, links: [{ text: 'Schedule a Call', href: '/products/call' }] },
      { title: 'Resources', open: false, links: [{ text: 'Documentation', href: documentationUrl, target: '_blank', onClick: handleDocumentationClick }, { text: 'Cloud Documentation', href: 'https://cloud.structure.io/' }, { text: 'EULA', href: '/eula' }] },
      { title: 'Support', open: false, links: [{ text: 'Help Center', href: 'https://support.structure.io' }, { text: 'Contact Us', href: 'https://structure.io/contact' }, { text: 'Release Notes', href: 'https://support.structure.io/article/417-structure-sdk-ios-release-notes' }] },
    ]);

    const openMenu = () => {
      mobileMenuClass.value = 'header-mobile-menu-open';
      mobileMenuOpen.value = true;
    };

    const closeMenu = () => {
      mobileMenuClass.value = 'header-mobile-menu-closed';
      mobileMenuOpen.value = false;
    };

    const isMobile = ref(window.innerWidth <= MOBILE_BREAKPOINT);

    const updateIsMobile = () => {
      isMobile.value = window.innerWidth <= MOBILE_BREAKPOINT;
    };


    watch(isMobile, (nowMobile, wasMobile) => {
      if (wasMobile && !nowMobile) {
        closeMenu();
      }
    });

    const toggleAccordion = (item) => {
      const index = mobileMenuItems.value.indexOf(item);
      if (index !== -1) {
        mobileMenuItems.value[index] = { ...item, open: !item.open }; // Reassign the object to ensure reactivity
      }
    };

    const isOnPublicRoute = computed(() => route.meta.public);


    const mobileIcon = (icon) => require(`@/assets/images/icons/${icon}.svg`);

    onMounted(() => {
      updateIsMobile();
      window.addEventListener('resize', updateIsMobile);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateIsMobile);
    });

    return {
      isAuthenticated,
      handleLogin,
      handleLogout,
      handleDocumentationClick,
      documentationUrl,
      isMobile,
      openMenu,
      closeMenu,
      mobileIcon,
      mobileMenuClass,
      mobileMenuItems,
      mobileMenuOpen,
      toggleAccordion,
      isOnPublicRoute,
      router
    };
  },
};
</script>

<style scoped lang="scss">
    @import '@/assets/styles/DashboardTopNav.scss'
    @import '@/assets/styles/StrButtons.scss'
</style>